import React from "react";
import { RotateCcw, X } from "lucide-react";

export default function ResultScreen({ generated, onRetake, onFinish }) {
  return (
    <div
      className="relative min-h-screen w-full flex flex-col px-4 sm:px-8 pt-3 pb-6"
      data-testid="result-screen"
    >
      {/* Header */}
      <div className="text-center mb-3 fade-up">
        <p className="text-[#A1A1AA] text-[10px] sm:text-xs tracking-[0.4em] uppercase">
          Korak 3 / 3
        </p>
        <h2
          className="font-display tracking-bond text-[#C9A961] text-2xl sm:text-3xl md:text-4xl uppercase mt-1"
          data-testid="result-title"
        >
          Tvoja tajna identiteta
        </h2>
        <div className="mx-auto mt-2 w-20 h-px bg-[#C9A961]/40" />
        <p className="mt-2 text-[#A1A1AA] text-xs sm:text-sm tracking-wider">
          Prenos in tisk fotografije sta na voljo pri hostesi.
        </p>
      </div>

      {/* Photo — sized so the action buttons below it land around the middle
          of a portrait kiosk screen (reachable height) */}
      <div className="flex justify-center fade-up fade-up-d1">
        <div
          className="print-target relative aspect-[3/4] max-w-full rounded-lg overflow-hidden border border-[#C9A961]/40 bg-black shadow-[0_0_60px_rgba(201,169,97,0.15)]"
          style={{ height: "min(52vh, 1100px)" }}
          data-testid="result-photo-frame"
        >
          <img
            src={generated.dataUrl}
            alt="Agent 100"
            className="w-full h-full object-cover"
            data-testid="result-photo"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="mt-4 grid grid-cols-2 gap-3 sm:gap-4 max-w-xl w-full mx-auto fade-up fade-up-d2">
        <ActionButton
          testId="retake-button"
          icon={<RotateCcw size={20} />}
          label="Ponovno"
          onClick={onRetake}
        />
        <ActionButton
          testId="finish-button"
          icon={<X size={20} />}
          label="Zaključi"
          onClick={onFinish}
        />
      </div>
    </div>
  );
}

function ActionButton({ icon, label, onClick, primary, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex flex-col sm:flex-row items-center justify-center gap-2 py-5 sm:py-6 border uppercase tracking-bond font-medium text-xs sm:text-sm transition-all duration-300 active:scale-[0.98] ${
        primary
          ? "border-[#C9A961] text-[#C9A961] hover:bg-[#C9A961]/10"
          : "border-white/15 text-white/70 hover:border-white/40 hover:text-white"
      }`}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
